import React from 'react';
import { ShipmentStatus } from '../../types/shipment.types';
import { Badge } from '../../components/Badge'; // Standardized named import
import { BadgeVariant } from '../../components/Badge/Badge.types';

interface ShipmentStatusBadgeProps {
  status: ShipmentStatus;
}

/**
 * Component to display shipment status as a colored badge
 * Uses different colors based on the status value:
 * - Created: Gray (default)
 * - Shipped: Light green (primary)
 * - Missing: Blue (info)
 * - Delivered: Green (success)
 */
const ShipmentStatusBadge = ({ status }: ShipmentStatusBadgeProps): React.ReactElement => {
  // Map shipment status to badge variant
  const getBadgeVariant = (): BadgeVariant => {
    switch (status) {
      case ShipmentStatus.DELIVERED:
        return 'success';
      case ShipmentStatus.SHIPPED:
        return 'primary';
      case ShipmentStatus.MISSING:
        return 'info';
      case ShipmentStatus.CREATED:
      default:
        return 'default';
    }
  };

  return <Badge label={status} variant={getBadgeVariant()} size="md" />;
};

export default ShipmentStatusBadge;